var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_5362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 20.5H5C3.67441 20.4984 2.40356 19.9711 1.46622 19.0338C0.528882 18.0964 0.00158786 16.8256 0 15.5L0 5.5C0.00158786 4.17441 0.528882 2.90356 1.46622 1.96622C2.40356 1.02888 3.67441 0.501588 5 0.5L15 0.5C16.3256 0.501588 17.5964 1.02888 18.5338 1.96622C19.4711 2.90356 19.9984 4.17441 20 5.5V15.5C19.9984 16.8256 19.4711 18.0964 18.5338 19.0338C17.5964 19.9711 16.3256 20.4984 15 20.5ZM5 2.5C4.20435 2.5 3.44129 2.81607 2.87868 3.37868C2.31607 3.94129 2 4.70435 2 5.5V15.5C2 16.2956 2.31607 17.0587 2.87868 17.6213C3.44129 18.1839 4.20435 18.5 5 18.5H15C15.7956 18.5 16.5587 18.1839 17.1213 17.6213C17.6839 17.0587 18 16.2956 18 15.5V5.5C18 4.70435 17.6839 3.94129 17.1213 3.37868C16.5587 2.81607 15.7956 2.5 15 2.5H5ZM24 19.5V6.5C24 6.23478 23.8946 5.98043 23.7071 5.79289C23.5196 5.60536 23.2652 5.5 23 5.5C22.7348 5.5 22.4804 5.60536 22.2929 5.79289C22.1054 5.98043 22 6.23478 22 6.5V19.5C22 20.2956 21.6839 21.0587 21.1213 21.6213C20.5587 22.1839 19.7956 22.5 19 22.5H6C5.73478 22.5 5.48043 22.6054 5.29289 22.7929C5.10536 22.9804 5 23.2348 5 23.5C5 23.7652 5.10536 24.0196 5.29289 24.2071C5.48043 24.3946 5.73478 24.5 6 24.5H19C20.3256 24.4984 21.5964 23.9711 22.5338 23.0338C23.4711 22.0964 23.9984 20.8256 24 19.5Z",
    fill: "#1E3F76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_5362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.230bef19b9ab81345801b91b9e740474.svg";
export { ForwardRef as ReactComponent };